import React from "react";
import { Form } from "react-bootstrap";

export const StepTwoVendor = () => {
  return (
    <div className="step-form">
      <Form>
        <Form.Group controlId="formBasicVendor">
          <Form.Label>Vendor</Form.Label>
          <Form.Check type="radio" checked label="LIFESCAN" name="LIFESCAN" id="LIFESCAN" className="form-check-ques" />
        </Form.Group>
      </Form>
    </div>
  );
};
